// extracted by mini-css-extract-plugin
export default {"cell":"_9llOnGumna","cell-centered":"_3Sz61MDJU6","cellCentered":"_3Sz61MDJU6","cell-left":"_2ijUUorWxm","cellLeft":"_2ijUUorWxm","cell-small":"_2tBPguF_s5","cellSmall":"_2tBPguF_s5","cell-right":"_1OIpR-m90O","cellRight":"_1OIpR-m90O","cell-head":"_1M4_9IDMcP","cellHead":"_1M4_9IDMcP","cell-data":"Ew99PF8ge_","cellData":"Ew99PF8ge_"};
    if(module.hot) {
      // 1633091769954
      var cssReload = require("!../../../../../node_modules/css-hot-loader/hotModuleReplacement.js")(module.id, {"fileMap":"{fileName}"});
      module.hot.dispose(cssReload);
      module.hot.accept(undefined, cssReload);;
    }
  